/* istanbul ignore file -- Client app related file */
import { ThemeProvider, EmotionCacheProvider } from '@ori-ui/mui';
import { AuthorizationCodeTokenClient, doDevelopmentLogin, IDENTITY_CLIENT_ID, OidcUrlHelper, UniversalTokenProvider } from '@ori/auth';
import { parseClientAppConfig } from '@ori/client-app-config';
import { ApplicationInsights, ErrorBoundary, getClientApplicationInsightsConfig } from '@ori/logger';
import { App } from './App';
import { EMOTION_CACHE_KEY } from './constants-generated';
import { mainLogger } from './logger';
import { jsx as _jsx } from "react/jsx-runtime";
const localLogger = mainLogger.createChild('appRender');
export async function render(rootElement) {
  // Handle iframe redirect stop app after getting auth code to not duplicate itself as we can't use router
  const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
  const {
    config = ''
  } = rootElement.dataset;
  const {
    customerId,
    ...appConfig
  } = parseClientAppConfig(config, []);
  const {
    identityUrl,
    tenant
  } = appConfig;

  // Initialize Application Insights in production
  if (process.env.NODE_ENV === 'production') {
    ApplicationInsights.initialize(getClientApplicationInsightsConfig());
  }
  // When using Requestly we do not want to load token
  else if (process.env.REACT_APP_USE_REQUESTLY === '1') {
    localLogger.debug('USING REQUESTLY');
  }
  // Get token for local development
  else if (process.env.REACT_APP_ANONYMOUS_MODE !== '1') {
    if (identityUrl) {
      await doDevelopmentLogin({
        identityUrl,
        tenant
      });
    } else {
      localLogger.error(new Error('Missing Identity URL!', {
        cause: identityUrl
      }));
    }
  }
  // extract token from URL; only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== 'production' && searchParams.has('state')) {
    const oidcUrlHelper = new OidcUrlHelper();
    const tokenClient = new AuthorizationCodeTokenClient({
      clientId: IDENTITY_CLIENT_ID,
      identityUrl
    });
    oidcUrlHelper.storeAuthCodeFromParams(searchParams);
    await tokenClient.initializeTokenFromAuthorizationCode();
    oidcUrlHelper.handleRedirectAfterLogin();
  }
  const {
    createRoot
  } = await import('react-dom/client');
  createRoot(rootElement).render(/*#__PURE__*/_jsx(ErrorBoundary, {
    logger: localLogger,
    children: /*#__PURE__*/_jsx(UniversalTokenProvider, {
      customerId: customerId,
      initialToken: "",
      children: /*#__PURE__*/_jsx(EmotionCacheProvider, {
        cacheKey: EMOTION_CACHE_KEY,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(App, {
            ...appConfig
          })
        })
      })
    })
  }));
}